import React from 'react'
import { Form } from 'react-bootstrap'

export default function MetricListForm({ metricList, register, errors }) {
	return (
		<React.Fragment>
			<Form.Group>
				<Form.Label>Nombre del Listado de Metricas <span className="text-danger">*</span></Form.Label>
				<Form.Control 
					{...register("name", {required: true})} 
					defaultValue={metricList && metricList.name} 
				/>
				{ errors.name && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
			</Form.Group>
			<Form.Group>
				<Form.Label>Estado</Form.Label>
				<Form.Control as="select" {...register('active',{required:true})} defaultValue={metricList && metricList.active}>
					<option value="1">Activo</option>
					<option value="0">Inactivo</option>
				</Form.Control>
			</Form.Group>
		</React.Fragment>
	)
}